module.exports = __webpack_public_path__ + "assets/img/td2.96aa286a.png";